import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import icSuccessIcon from 'assets/svg/ic_success.svg';
import icClose from 'assets/svg/ic_close.svg';
import { formatCurrency } from '@wolffun/system-currency';
import Modal from 'src/Components/Modal';
import { parseCosmeticType } from 'src/Pages/MarketplaceV2/Components/MarketCosmetic/utils';
import { formatDateTime } from 'src/utils/date';

const TransactionDetailModal = ({
  cosmetic,
  onClose,
  balance
}) => {
  const {
    tokenId: cosmeticId,
    cosmeticName,
    cosmeticType
  } = cosmetic || {};
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    src: icClose
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.iconContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: icSuccessIcon
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, /*#__PURE__*/React.createElement("span", null, "Complete!")), /*#__PURE__*/React.createElement("div", {
    className: styles.description
  }, /*#__PURE__*/React.createElement("span", null, "You successfully bought #", cosmeticId, " - \xA0", parseCosmeticType(cosmeticType), cosmeticName)), /*#__PURE__*/React.createElement("div", {
    className: styles.detailRow
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Your balance")), /*#__PURE__*/React.createElement("div", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("span", null, balance && formatCurrency(balance, {
    withCurrency: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles.detailRow
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Time"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, formatDateTime(new Date()))), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement("button", {
    className: classNames(styles.button, styles.primary),
    onClick: onClose
  }, /*#__PURE__*/React.createElement("span", null, "I got it")))));
};

export default TransactionDetailModal;